<div class="content-style-class">
  <div fxLayout="row" fxLayoutAlign="space-between center">
    <div fxLayout="column">
      <h2 class="title-style">{{ measurePageTitle }}</h2>
    </div>
    
    <div fxLayout="row" fxLayoutGap="5px" class="add-button-style">
      <span #myMeasuresButton fxLayoutAlign="end" class="buttons-container" (click)="loadMyMeasures()">
        {{ myMeasureTitle }}
      </span>
    
    </div>
  </div>
  <div fxLayout="row" class="content-block">
    <div class="dx-card responsive-paddings card-radius">
      <abc-grid
        #measureGrid
        class="grid-group-by-Style chech-box-Column custome-export-style abc-grid-custom-style"
        [height]="'100%'"
        [rowAlternationEnabled]="false"
        [noDataText]="noDataText"
        [setupDefaultLayoutOnInitialization]="true"
        [columnChooser]="{ search: { enabled: true }, enabled: true }"
        [showRowLines]="false"
        [selectionMode]="selectionMode"
        [columns]="columnsHeader"
        [dataSource]="measures"
        (onRowDblClick)="openMeasureDetails($event)"
        (onContentReady)="onContentReady($event)"
        (onCellHoverChanged)="hoverTooltip($event)"
        (onCellPrepared)="onCellPrepared($event)"
        (onCellClick)="onCellClick($event)"
        (onExporting)="dataService.onExporting($event, exportFileName)"
      >
        <dxo-export [enabled]="true" [allowExportSelectedData]="false" [formats]="['pdf', 'xlsx']"></dxo-export>
        <dxo-header-filter [visible]="true"></dxo-header-filter>
        <dxo-paging [enabled]="false"></dxo-paging>
        <dxo-group-panel #dxGroup [visible]="true"></dxo-group-panel>
        <dxo-editing [allowAdding]="false"> </dxo-editing>
        <dxo-filter-row [visible]="true"></dxo-filter-row>
        <dxo-filter-panel [visible]="true"></dxo-filter-panel>
        <dxo-search-panel [visible]="true"> </dxo-search-panel>
        <dxo-summary>
          <dxi-group-item
            column="ParentId"
            summaryType="count"
            displayFormat="{{ dataService.res('Ubt-Report-Total') }}: {0}"
          >
          </dxi-group-item>
          <dxi-total-item
            column="Designation"
            summaryType="count"
            displayFormat="{{ dataService.res('Ubt-Report-Total') }}: {0}"
          >
          </dxi-total-item>
        </dxo-summary>
      </abc-grid>
      <dx-tooltip [target]="TooltipTarget" [visible]="isVisible">
        <div *dxTemplate="let data of 'content'">
          <div class="tooltip-target">
            {{ ToolTipText }}
          </div>
        </div>
      </dx-tooltip>
      <div  *appCheckPermission=" { module: 'Measure', action: Action.CREATE} ">
      <dx-speed-dial-action icon="add" [index]="1" (onClick)="openCreationPopup()"> </dx-speed-dial-action>
      </div>
    </div>
  </div>
  <abc-popup
    #measureCreationForm
    fxLayout="column"
    fxLayoutAlign="center center"
    [width]="'60%'"
    [height]="'auto'"
    [showTitle]="true"
    title="{{ dataService.res('Ubt-MeasureList-Create-Measure') }}"
    [showCloseButton]="true"
  >
  
    <ubt-geods-create-measure (closePopup)="closeCreationPopup()"></ubt-geods-create-measure>
  
  </abc-popup>
  <abc-popup
    #confirmDeletePopup
    [width]="'25%'"
    fxLayout="column"
    fxLayoutAlign="center center"
    [height]="'auto'"
    [title]="dataService.res('Ubt-MeasureList-Confirm-Delete')"
    [showCloseButton]="true"
  >
    <div class="dx-card popup-card-paddings card-radius" fxLayout="column" fxLayoutGap="20px" fxFlexFill>
      <div fxLayout="column" fxLayoutAlign="center center" fxLayoutGap="20px">
        {{ dataService.res('Ubt-MeasureList-Delete-Message') }}
      </div>
      <dxi-item itemType="group" fxLayout="row" fxLayoutAlign="end end" fxLayoutGap="20px">
        <dx-button
          class="submit-button"
          [text]="dataService.res('Ubt-Company-Icon-Delete')"
          (onClick)="removeMeasure()"
        >
        </dx-button>
        <dx-button
          class="cancel-button"
          [text]="dataService.res('Ubt-Company-Button-Cancel')"
          (onClick)="abortDelete()"
        >
        </dx-button>
      </dxi-item>
    </div>
  </abc-popup>
</div>

<abc-context-menu
  #contextMenu
  id="contextMenu"
  class="abc-context-menu"
  showEvent="abcclick"
  [items]="contextMenuItems"
  [position]="{ my: 'top right', at: 'bottom right' }"
>
</abc-context-menu>
